import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Box, Typography, Button, Stack, CircularProgress, Tabs, Tab } from '@mui/material';
import TableCanvas from './TableCanvas';
import TableModal from './TableModal';
import ParticipantList from './ParticipantList';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { API_ENDPOINTS } from '../../config/api';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, Select, MenuItem, FormControl, InputLabel, Button as MuiButton, Grid
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import AddParticipantModal from './AddParticipantModal';
import MasalarTab from './MasalarTab';
import SemaTab from './SemaTab';
import MisafirlerTab from './MisafirlerTab';
import PrintIcon from '@mui/icons-material/Print';

const SeatingPlan = () => {
    const { codeHash } = useParams();
    const navigate = useNavigate();
    const [tables, setTables] = useState([]);
    const [participants, setParticipants] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedTable, setSelectedTable] = useState(null);
    const [participantDialogOpen, setParticipantDialogOpen] = useState(false);
    const [participantForm, setParticipantForm] = useState({
      name: '',
      phone: '',
      email: '',
      side: 'bride',
      status: 'invited',
      notes: ''
    });
    const [participantSearch, setParticipantSearch] = useState('');
    const [participantStatus, setParticipantStatus] = useState('all');
    const [sides, setSides] = useState([]);
    const [editingParticipant, setEditingParticipant] = useState(null);
    const [tabValue, setTabValue] = useState(() => localStorage.getItem('seatingTab') || 'schema');

    const handleTabChange = (event, newValue) => {
      setTabValue(newValue);
      localStorage.setItem('seatingTab', newValue);
    };

    // Modern yazdırma fonksiyonu: Her masa için masa adı ve katılımcı isimleriyle sade çıktı
    const handlePrintSimple = () => {
      const printWindow = window.open('', '', 'width=900,height=1200');
      let html = '<html><head><title>Oturma Planı Yazdır</title>';
      html += `<style>
        body{font-family:sans-serif;margin:0;padding:0;}
        .page{page-break-after:always;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;min-height:100vh;padding:20px;box-sizing:border-box;}
        .wreath-wrap{position:relative;display:flex;align-items:center;justify-content:center;margin:20px 0 15px 0;width:100%;max-width:300px;}
        .wreath{display:block;width:100%;max-width:300px;height:auto;}
        .masa-title-center{
          position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);
          font-size:1.4rem;font-weight:700;max-width:220px;text-align:center;word-break:break-word;line-height:1.2;
          color:#333;
        }
        .names{font-size:1.2rem;text-align:center;margin-top:10px;width:100%;max-width:400px;}
        .names div{padding:5px 0;border-bottom:1px solid #eee;}
        .names div:last-child{border-bottom:none;}
        
        /* Mobil uyumluluk */
        @media screen and (max-width: 768px) {
          .page{padding:15px;min-height:100vh;}
          .wreath-wrap{margin:15px 0 10px 0;max-width:250px;}
          .wreath{max-width:250px;}
          .masa-title-center{font-size:1.2rem;max-width:180px;line-height:1.1;}
          .names{font-size:1rem;margin-top:8px;}
          .names div{padding:4px 0;}
        }
        
        @media screen and (max-width: 480px) {
          .page{padding:10px;}
          .wreath-wrap{margin:10px 0 8px 0;max-width:200px;}
          .wreath{max-width:200px;}
          .masa-title-center{font-size:1rem;max-width:150px;line-height:1.1;}
          .names{font-size:0.9rem;margin-top:6px;}
          .names div{padding:3px 0;}
        }
        
        /* Yazdırma için özel ayarlar */
        @media print {
          .page{page-break-after:always;min-height:100vh;padding:0;}
          .wreath-wrap{margin:30px 0 20px 0;}
          .masa-title-center{font-size:1.3rem;}
          .names{font-size:1.1rem;margin-top:15px;}
        }
      </style>`;
      html += '</head><body>';
      tables.forEach(table => {
        html += '<div class="page">';
        html += '<div class="wreath-wrap">';
        html += '<img class="wreath" src="/assets/images/wreath.png" alt="wreath" />';
        html += `<div class="masa-title-center">${table.name.replace(/ /g, ' <wbr>')}</div>`;
        html += '</div>';
        html += '<div class="names">';
        const seats = (table.seats || []).filter(s => s.participant_id);
        seats.forEach(s => {
          const p = participants.find(p => p.id === s.participant_id);
          if (p) html += `<div>${p.name}</div>`;
        });
        html += '</div></div>';
      });
      html += '</body></html>';
      printWindow.document.write(html);
      printWindow.document.close();
      setTimeout(() => { printWindow.print(); printWindow.close(); }, 500);
    };

    const fetchData = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('authToken');

            const [tablesRes, participantsRes] = await Promise.all([
                fetch(API_ENDPOINTS.seating.getAll(codeHash), {
                    headers: { 'Authorization': `Bearer ${token}` },
                    credentials: 'include'
                }),
                fetch(API_ENDPOINTS.events.getParticipants(codeHash), {
                    headers: { 'Authorization': `Bearer ${token}` },
                    credentials: 'include'
                })
            ]);

            const tablesData = await tablesRes.json();
            const participantsData = await participantsRes.json();

            setTables(Array.isArray(tablesData) ? tablesData : []);
            setParticipants(Array.isArray(participantsData) ? participantsData : []);
            // --- DİNAMİK TARAF LİSTESİ ---
            setSides(
              Array.from(
                new Set(
                  (participantsData || [])
                    .map(p => p.side)
                    .filter(Boolean)
                )
              )
            );
        } catch (e) {
            console.error('Veri çekme hatası:', e);
            setTables([]);
            setParticipants([]);
            setSides([]); // hata durumunda da sides sıfırlansın
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        // eslint-disable-next-line
    }, [codeHash]);

    const handleBack = () => {
        navigate(`/event/${codeHash}/participants`);
    };

    const handleOpenModal = (table = null) => {
        setSelectedTable(table);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setSelectedTable(null);
        setModalOpen(false);
    };

    const handleTableSaved = () => {
        handleCloseModal();
        fetchData();
    };

    const handleOpenParticipantDialog = (participant = null) => {
      setEditingParticipant(participant);
      setParticipantDialogOpen(true);
    };
    const handleCloseParticipantDialog = () => {
      setParticipantDialogOpen(false);
      setEditingParticipant(null);
    };
    const handleParticipantSave = async (form) => {
      try {
        let url, method;
        if (editingParticipant) {
          url = API_ENDPOINTS.events.updateParticipant(codeHash, editingParticipant.id);
          method = 'PUT';
        } else {
          url = API_ENDPOINTS.events.addParticipant(codeHash);
          method = 'POST';
        }
        const response = await fetch(url, {
          method,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`
          },
          body: JSON.stringify(form)
        });
        if (response.ok) {
          handleCloseParticipantDialog();
          const updated = await response.json();
          setParticipants(prev => {
            if (editingParticipant) {
              return prev.map(p => p.id === editingParticipant.id ? { ...p, ...form } : p);
            } else {
              return [...prev, updated];
            }
          });
          // sides güncellemesi de yapılmalı
          setSides(prev => prev.includes(form.side) ? prev : [...prev, form.side]);
        } else {
          const data = await response.json();
          alert(data.error || 'Katılımcı eklenemedi');
        }
      } catch (error) {
        alert('Katılımcı eklenemedi');
      }
    };

    const handleAddSide = async (newSide) => {
      if (!newSide.trim()) return;
      if (sides.includes(newSide)) return;
      const updatedSides = [...sides, newSide];
      setSides(updatedSides);
    };
    const handleDeleteSide = async (sideToDelete) => {
      const updatedSides = sides.filter(side => side !== sideToDelete);
      setSides(updatedSides);
    };

    // Katılımcı listesi filtreleme
    const filteredParticipants = participants.filter(p => {
      const matchesName = participantSearch === '' || (p.name && p.name.toLowerCase().includes(participantSearch.toLowerCase()));
      const matchesStatus = participantStatus === 'all' || p.status === participantStatus;
      return matchesName && matchesStatus;
    });

    // Katılımcı raporu: toplam ve yerleştirilen
    const totalParticipants = participants.length;
    const assignedParticipants = tables.reduce((acc, t) => acc + (t.seats ? t.seats.filter(s => s.participant_id).length : 0), 0);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>
            <Box sx={{ 
                display: 'flex', 
                flexDirection: { xs: 'column', md: 'row' }, 
                alignItems: { xs: 'stretch', md: 'center' }, 
                justifyContent: 'space-between', 
                mb: 3, 
                gap: 3,
                backgroundColor: 'background.paper',
                borderRadius: 2,
                p: 3,
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
            }}>
                <Typography variant="h5" sx={{ 
                    order: { xs: 1, md: 1 },
                    fontWeight: 700,
                    color: 'primary.main'
                }}>
                    Oturma Planı
                    <Typography component="span" variant="caption" color="text.secondary" sx={{ 
                        ml: 2, 
                        fontWeight: 400,
                        backgroundColor: 'grey.100',
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: '0.75rem'
                    }}>
                        {totalParticipants} kişiden {assignedParticipants} kişi yerleştirildi
                    </Typography>
                </Typography>
                
                <Stack direction="row" spacing={2} alignItems="center" sx={{ 
                    order: { xs: 2, md: 2 }, 
                    flexWrap: 'wrap', 
                    justifyContent: { xs: 'center', md: 'flex-end' },
                    '& .MuiButton-root': {
                        borderRadius: 2,
                        textTransform: 'none',
                        fontWeight: 600,
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        transition: 'all 0.2s ease-in-out',
                        '&:hover': {
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                        }
                    }
                }}>
                    <Button 
                        variant="outlined" 
                        startIcon={<ArrowBackIcon />} 
                        onClick={handleBack}
                        sx={{
                            borderColor: 'primary.main',
                            color: 'primary.main',
                            '&:hover': {
                                borderColor: 'primary.dark',
                                backgroundColor: 'primary.50'
                            }
                        }}
                    >
                        Katılımcı Listesine Dön
                    </Button>
                    <Button 
                        variant="contained" 
                        startIcon={<AddIcon />} 
                        onClick={() => handleOpenModal()}
                        sx={{
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.dark'
                            }
                        }}
                    >
                        Masa Ekle
                    </Button>
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        startIcon={<AddIcon />} 
                        onClick={() => handleOpenParticipantDialog()}
                        sx={{
                            backgroundColor: 'secondary.main',
                            '&:hover': {
                                backgroundColor: 'secondary.dark'
                            }
                        }}
                    >
                        Katılımcı Ekle
                    </Button>
                    <Button 
                        startIcon={<PrintIcon />} 
                        color="primary" 
                        variant="outlined" 
                        onClick={handlePrintSimple}
                        sx={{
                            borderColor: 'success.main',
                            color: 'success.main',
                            '&:hover': {
                                borderColor: 'success.dark',
                                backgroundColor: 'success.50'
                            }
                        }}
                    >
                        Yazdır
                    </Button>
                </Stack>
            </Box>
            <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 2 }}>
              <Tab label="Masalar" value="tables" />
              <Tab label="Misafirler" value="guests" />
              <Tab label="Şema" value="schema" />
            </Tabs>
            {tabValue === 'tables' && (
              <MasalarTab tables={tables} participants={participants} onTableEdit={handleOpenModal} />
            )}
            {tabValue === 'guests' && (
              <MisafirlerTab participants={participants} tables={tables} onEditParticipant={handleOpenParticipantDialog} />
            )}
            {tabValue === 'schema' && (
              <SemaTab
                tables={tables}
                setTables={setTables}
                participants={participants}
                onTableEdit={handleOpenModal}
                onChange={fetchData}
                codeHash={codeHash}
                onEditParticipant={handleOpenParticipantDialog}
              />
            )}
            <TableModal
                open={modalOpen}
                onClose={handleCloseModal}
                onSaved={handleTableSaved}
                table={selectedTable}
                codeHash={codeHash}
                defaultOrderNo={Math.max(0, ...tables.map(t => t.order_no || 0)) + 1}
            />
            <AddParticipantModal
              open={participantDialogOpen}
              onClose={handleCloseParticipantDialog}
              onSaved={handleParticipantSave}
              sides={sides}
              onAddSide={handleAddSide}
              onDeleteSide={handleDeleteSide}
              participant={editingParticipant}
            />
        </Container>
    );
};

export default SeatingPlan;
